<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="用户名：" prop="username">
                <el-input v-model="model.username"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="realname">
                <el-input v-model="model.realname"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <el-input v-model="model.cellphone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail">
                <el-input v-model="model.mail"></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所在集团：" prop="group_id">
                <el-select v-model="model.group_id" clearable placeholder="请选择集团">
                    <el-option v-for="item in groupList" :key="'pl'+item.id" :label="item.group_name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { allGroup } from '@/api/projectgroup'

export default {
    name: 'userEdit',
    mixins: [editutil],
    data() {
        return {
            exits_p_name:'username',
            exits_p_title:'用户名',
            model: {
                username: '',
                realname: '',
                cellphone: '',
                state: '1',
                group_id: '',
            },
            getObj:{
                url:'/api/admin/user/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['userstate'],
            checkObj:{
                url:'/api/admin/user/check',
                data:{}
            },
            rules: {
                username: [
                    {required: true, message: '用户名不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                realname: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '手机号不能为空', trigger: 'blur'}
                ],
                group_id: [
                    {required: true, message: '所在集团不能为空', trigger: 'blur'}
                ]
            },
            groupList: [],
        }
    },
    methods: {
        loadOtherData() {
            allGroup().then(res=>{
                if(res.code == 1){
                    this.groupList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/groupuser/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        },
        formateData(){
            this.model.state = this.model.state+""
        },
        selOrg(val){
            this.model.org_id = val
        },
    }
};
</script>